import { useImmer } from "use-immer";

export function useQuizProgress({
  step,
  contentBlocksGroups,
}: {
  step: RoadmapStepVM;
  contentBlocksGroups: Array<{ content: ContentBlock[] }>;
}): {
  initialScore: ClinicalCaseClientQuizScore;
  initialBlocksGroupIndex: number;
  score: ClinicalCaseClientQuizScore;
  setScore: ReturnType<typeof useImmer<ClinicalCaseClientQuizScore>>[1];
} {
  const { initialScore, initialBlocksGroupIndex } = calculateInitialProgress(
    step,
    contentBlocksGroups,
  );
  const [score, setScore] = useImmer<ClinicalCaseClientQuizScore>(initialScore);

  return {
    initialScore,
    initialBlocksGroupIndex,
    score,
    setScore,
  };
}

function calculateInitialProgress(
  step: RoadmapStepVM,
  contentBlocksGroups: Array<{ content: ContentBlock[] }>,
) {
  const score: ClinicalCaseClientQuizScore = {};
  let latestGroupIndex = 0;

  // If step is finished, show all groups
  if (step.progress?.isCompleted) {
    latestGroupIndex = contentBlocksGroups.length - 1;
  }

  if (step.progress?.quizzes) {
    step.progress.quizzes.forEach((quizAnswer: RoadmapStepQuizProgressVM) => {
      for (
        let groupIndex = 0;
        groupIndex < contentBlocksGroups.length;
        groupIndex++
      ) {
        const group = contentBlocksGroups[groupIndex];
        for (const block of group.content) {
          if (
            block.type === "quiz" &&
            block.data.uuid === quizAnswer.questionUuid
          ) {
            const quiz = block.data;
            const selectedIndices = quizAnswer.answerUuids
              .map((answerUuid: string) =>
                quiz.options.findIndex(
                  (option: { uuid: string }) => option.uuid === answerUuid,
                ),
              )
              .filter((idx: number) => idx !== -1);

            score[quiz.uuid] = {
              correct: quizAnswer.isCorrect,
              selected: selectedIndices,
            };

            // Only track latest group if step is not finished
            if (!step.progress?.isCompleted && groupIndex > latestGroupIndex) {
              latestGroupIndex = groupIndex;
            }
            break;
          }
        }
      }
    });
  }

  return { initialScore: score, initialBlocksGroupIndex: latestGroupIndex };
}
